<header class="background">
    <nav #navbar class="main-panel navbar navbar-expand-sm navbar-toggleable-sm navbar-dark bg-dark box-shadow">
        <div class="container-fluid">
            <div class="row g-0 w-100 justify-content-between">
                <img [src]="EurofinsIconPath" (click)="goToHome()" class="clickable col-auto">
                @if (CoreData.IsMobile && PageName) {
                <h5 class="col text-center my-auto" style="color: white;"> {{ PageName.substring(0, 40) }}</h5>
                }
                @if (!CoreData.IsMobile) {
                <div class="mx-3" style="height: 50px; width: 2px; background: white;"></div>
                }
                @if (!CoreData.IsMobile) {
                <span style="color: white; font-size: 32px;"> {{AppName}}</span>
                }
                <button #toggleButton class="navbar-toggler col-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded"
                        (click)="toggle()">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <!-- MOBILE UI -->
                @if (isMenuTogglerDisplayed() && IsLoggedIn() && CoreData.IsMobile) {
                <div class="collapse navbar-collapse" [ngClass]='{"show": isExpanded}' id="navbarSupportedContent">
                    <ul class="row g-0 m-0" style="list-style: none;">
                        <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link row d-flex" [routerLink]='[ENavigationRoute.InterventionList]' (click)="toggle()">
                                <div class="col-auto">
                                    <mat-icon class="material-symbols-outlined">home</mat-icon>
                                </div>
                                <div class="col text-start m-auto">Home</div>
                            </a>
                        </li>
                        <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link row d-flex" [routerLink]='[ENavigationRoute.Pointage]' (click)="toggle()">
                                <div class="col-auto">
                                    <mat-icon class="material-symbols-outlined">more_time</mat-icon>
                                </div>
                                <div class="col text-start m-auto">Pointage</div>
                            </a>
                        </li>
                        <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link row d-flex" [routerLink]='[ENavigationRoute.Metrologie]' (click)="toggle()">
                                <div class="col-auto">
                                    <mat-icon class="material-symbols-outlined">tune</mat-icon>
                                </div>
                                <div class="col text-start m-auto">Métrologie</div>
                            </a>
                        </li>
                        <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link row d-flex" (click)="showVersion();toggle()">
                                <div class="col-auto">
                                    <mat-icon class="material-symbols-outlined">help</mat-icon>
                                </div>
                                <div class="col text-start m-auto">A propos</div>
                            </a>
                        </li>
                        <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link row d-flex" (click)="exportDB();toggle()">
                                <div class="col-auto">
                                    <mat-icon class="material-symbols-outlined">build</mat-icon>
                                </div>
                                <div class="col text-start m-auto">Maintenance</div>
                            </a>
                        </li>
                        @if (!IsProduction) {
                        <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link row d-flex" (click)="importDB();toggle()">
                                <div class="col-auto">
                                    <mat-icon class="material-symbols-outlined">publish</mat-icon>
                                </div>
                                <div class="col text-start m-auto">Import DB</div>
                            </a>
                        </li>
                        }
                    </ul>
                </div>
                }
                <!-- DESKTOP UI -->
                @if (IsLoggedIn()) {
                <div class="collapse navbar-collapse justify-content-end" [ngClass]='{"show": !isMenuTogglerDisplayed()}'>
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item clickable" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link" [routerLink]='[ENavigationRoute.InterventionList]'>
                                <mat-icon class="material-symbols-outlined">home</mat-icon>
                                Home
                            </a>
                        </li>
                        <li class="nav-item clickable" [routerLinkActive]='["link-active"]'>
                            <a class="nav-link" [routerLink]='[ENavigationRoute.Pointage]'>
                                <mat-icon class="material-symbols-outlined">more_time</mat-icon>
                                Pointage
                            </a>
                        </li>
                    </ul>
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon class="material-symbols-outlined" style="color: white;">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <div mat-menu-item class="text-center">
                            Version: {{AppVersion}}
                        </div>
                        <div mat-menu-item class="text-center">
                            <div>{{CoreData.User?.FirstName}} {{CoreData.User?.LastName}}</div>
                        </div>
                    </mat-menu>
                </div>
                }
                @if (!IsLoggedIn()) {
                <div class="collapse navbar-collapse" style="height: 61px;">
                    <!-- This a dummy container to align the header -->
                </div>
                }
            </div>
        </div>
    </nav>
    <div class="container-fluid px-5 background-violet-500">
        @if (Opacity === 100) {
        <mat-progress-bar [style.opacity]="Opacity" mode="indeterminate" color="accent" role="progressbar" style="z-index: 9999;">
        </mat-progress-bar>
        }
        @if (Opacity !== 100) {
        <div style="height: 4px;"></div>
        }
    </div>
</header>